import { useEffect, useState } from 'react';
import { getBotInfo } from '../api.js';
import { openTelegramLink } from '../lib/twa.js';

export default function StartBotNotice() {
  const [botUsername, setBotUsername] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const info = await getBotInfo();
        if (!cancelled) setBotUsername(info.username || '');
      } catch {
        if (!cancelled) setBotUsername('');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const username = botUsername || 'your_bot';
  const link = `https://t.me/${username}?start=open`;

  return (
    <div className="notice">
      <h2>Bot start needed</h2>
      <p>
        Tap the button to start the bot in a private chat. After that, the calendar will be able to send you DM
        reminders about events you RSVP &ldquo;going&rdquo;.
      </p>
      <button onClick={() => openTelegramLink(link)}>Open @{username}</button>
    </div>
  );
}
